import React, { useState } from 'react';
import type { BaseIssue, IssueAssignee, TaskIssue } from '@momentum/types';
import { TaskRow } from '@/shared/components/tasks/TaskRow';
import type { FullIssueWithChildren } from '@/shared/utils/issue-guards';
import { ViewGoalDialog } from '@/features/goals/goal-view';

interface TasksTableRowProps {
  task: FullIssueWithChildren;
  currentEmployeeId?: string;
}

/**
 * Converts FullIssueWithChildren to BaseIssue for TaskRow component
 * FullIssueWithChildren has issueCreator (IssueAssignee) instead of creator (string)
 * and populated assignees (IssueAssignee[]) instead of string IDs
 */
const convertToBaseIssue = (task: FullIssueWithChildren): BaseIssue => {
  return {
    ...task,
    creator: task.issueCreator?._id || '',
    assignees: task.assignees?.map((assignee) => assignee._id) || [],
  } as BaseIssue;
};

export const TasksTableRow: React.FC<TasksTableRowProps> = ({
  task,
  currentEmployeeId,
}) => {
  const [showViewDialog, setShowViewDialog] = useState(false);
  const baseIssue = convertToBaseIssue(task);
  // Preserve populated assignees for avatar display
  const populatedAssignees: IssueAssignee[] = task.assignees || [];

  return (
    <>
      <TaskRow
        task={baseIssue as TaskIssue}
        onView={() => setShowViewDialog(true)}
        assignees={populatedAssignees}
        currentEmployeeId={currentEmployeeId}
      />
      <ViewGoalDialog
        goal={task}
        open={showViewDialog}
        onOpenChange={setShowViewDialog}
        currentEmployeeId={currentEmployeeId}
      />
    </>
  );
};
